var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$config.MODE,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',{attrs:{"max":2}},[_c('router-view')],1)],1),_c('modal'),_c('center-notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }